export var NKSelectXL = [
    // 0-16
    { NKSelectXL: { '0': 304.91, '600': 321.68, '1200': 254.91, '3000': 159.4 } },
    // 17-20
    {
        NKSelectXL: { '0': 366.67, '600': 361.78, '1200': 316.67, '3000': 279.97 },
    },
    // 21
    {
        NKSelectXL: { '0': 487.69, '600': 475.32, '1200': 384.13, '3000': 267.14 },
    },
    // 22
    {
        NKSelectXL: { '0': 497.48, '600': 486.72, '1200': 394.07, '3000': 274.99 },
    },
    // 23
    { NKSelectXL: { '0': 507.62, '600': 498.5, '1200': 404.34, '3000': 283.02 } },
    // 24
    {
        NKSelectXL: { '0': 518.02, '600': 510.62, '1200': 414.86, '3000': 291.19 },
    },
    // 25
    {
        NKSelectXL: { '0': 528.38, '600': 522.55, '1200': 425.34, '3000': 299.36 },
    },
    // 26
    {
        NKSelectXL: { '0': 538.77, '600': 534.44, '1200': 435.82, '3000': 307.61 },
    },
    // 27
    {
        NKSelectXL: { '0': 549.15, '600': 546.22, '1200': 446.29, '3000': 315.89 },
    },
    // 28
    { NKSelectXL: { '0': 559.49, '600': 557.87, '1200': 456.7, '3000': 324.19 } },
    // 29
    { NKSelectXL: { '0': 569.78, '600': 569.42, '1200': 467.04, '3000': 332.5 } },
    // 30
    { NKSelectXL: { '0': 579.9, '600': 580.75, '1200': 477.23, '3000': 340.74 } },
    // 31
    { NKSelectXL: { '0': 589.9, '600': 591.84, '1200': 487.26, '3000': 348.89 } },
    // 32
    {
        NKSelectXL: { '0': 599.75, '600': 602.73, '1200': 497.15, '3000': 356.98 },
    },
    // 33
    {
        NKSelectXL: { '0': 609.74, '600': 613.71, '1200': 507.15, '3000': 365.19 },
    },
    // 34
    {
        NKSelectXL: { '0': 619.85, '600': 624.79, '1200': 517.27, '3000': 373.54 },
    },
    // 35
    { NKSelectXL: { '0': 630.19, '600': 636.09, '1200': 527.62, '3000': 382.1 } },
    // 36
    {
        NKSelectXL: { '0': 640.94, '600': 647.82, '1200': 538.37, '3000': 391.02 },
    },
    // 37
    {
        NKSelectXL: { '0': 652.23, '600': 660.09, '1200': 549.65, '3000': 400.39 },
    },
    // 38
    {
        NKSelectXL: { '0': 664.03, '600': 672.94, '1200': 561.45, '3000': 410.21 },
    },
    // 39
    {
        NKSelectXL: { '0': 676.64, '600': 686.67, '1200': 574.05, '3000': 420.67 },
    },
    // 40
    {
        NKSelectXL: { '0': 689.69, '600': 700.81, '1200': 587.08, '3000': 431.58 },
    },
    // 41
    {
        NKSelectXL: { '0': 703.18, '600': 715.42, '1200': 600.56, '3000': 442.96 },
    },
    // 42
    {
        NKSelectXL: { '0': 717.22, '600': 730.59, '1200': 614.58, '3000': 454.86 },
    },
    // 43
    {
        NKSelectXL: { '0': 731.74, '600': 746.28, '1200': 629.08, '3000': 467.23 },
    },
    // 44
    {
        NKSelectXL: { '0': 746.68, '600': 762.42, '1200': 644.01, '3000': 480.03 },
    },
    // 45
    {
        NKSelectXL: { '0': 762.23, '600': 779.13, '1200': 659.54, '3000': 493.36 },
    },
    // 46
    { NKSelectXL: { '0': 778.34, '600': 796.38, '1200': 675.62, '3000': 507.2 } },
    // 47
    { NKSelectXL: { '0': 795, '600': 814.17, '1200': 692.26, '3000': 521.55 } },
    // 48
    {
        NKSelectXL: { '0': 812.18, '600': 832.47, '1200': 709.41, '3000': 536.41 },
    },
    // 49
    {
        NKSelectXL: { '0': 829.94, '600': 851.35, '1200': 727.14, '3000': 551.86 },
    },
    // 50
    { NKSelectXL: { '0': 848.2, '600': 870.75, '1200': 745.37, '3000': 567.82 } },
    // 51
    {
        NKSelectXL: { '0': 867.01, '600': 890.68, '1200': 764.16, '3000': 584.33 },
    },
    // 52
    {
        NKSelectXL: { '0': 886.48, '600': 911.25, '1200': 783.59, '3000': 601.51 },
    },
    // 53
    {
        NKSelectXL: { '0': 906.49, '600': 932.36, '1200': 803.57, '3000': 619.33 },
    },
    // 54
    { NKSelectXL: { '0': 926.94, '600': 953.87, '1200': 824, '3000': 637.74 } },
    // 55
    { NKSelectXL: { '0': 948.09, '600': 976.11, '1200': 845.1, '3000': 656.95 } },
    // 56
    {
        NKSelectXL: { '0': 969.65, '600': 998.74, '1200': 866.62, '3000': 676.78 },
    },
    // 57
    {
        NKSelectXL: { '0': 991.97, '600': 1022.1, '1200': 888.88, '3000': 697.49 },
    },
    // 58
    {
        NKSelectXL: { '0': 1014.73, '600': 1045.89, '1200': 911.6, '3000': 718.92 },
    },
    // 59
    {
        NKSelectXL: {
            '0': 1038.33,
            '600': 1070.53,
            '1200': 935.12,
            '3000': 741.35,
        },
    },
    // 60
    {
        NKSelectXL: {
            '0': 1062.59,
            '600': 1095.76,
            '1200': 959.31,
            '3000': 764.72,
        },
    },
    // 61
    {
        NKSelectXL: {
            '0': 1087.53,
            '600': 1121.55,
            '1200': 984.18,
            '3000': 789.07,
        },
    },
    // 62
    {
        NKSelectXL: {
            '0': 1112.88,
            '600': 1147.61,
            '1200': 1009.46,
            '3000': 814.32,
        },
    },
    // 63
    {
        NKSelectXL: {
            '0': 1138.76,
            '600': 1173.94,
            '1200': 1035.25,
            '3000': 840.57,
        },
    },
    // 64
    {
        NKSelectXL: {
            '0': 1164.89,
            '600': 1200.43,
            '1200': 1061.3,
            '3000': 867.81,
        },
    },
    // 65
    {
        NKSelectXL: {
            '0': 1189.32,
            '600': 1225.09,
            '1200': 1085.73,
            '3000': 893.94,
        },
    },
    // 66
    {
        NKSelectXL: {
            '0': 1213.66,
            '600': 1249.66,
            '1200': 1110.08,
            '3000': 920.02,
        },
    },
    // 67
    {
        NKSelectXL: {
            '0': 1237.89,
            '600': 1274.03,
            '1200': 1134.31,
            '3000': 945.98,
        },
    },
    // 68
    {
        NKSelectXL: { '0': 1261.9, '600': 1298.09, '1200': 1158.32, '3000': 971.7 },
    },
    // 69
    {
        NKSelectXL: {
            '0': 1285.55,
            '600': 1321.75,
            '1200': 1181.97,
            '3000': 997.03,
        },
    },
    // 70
    {
        NKSelectXL: {
            '0': 1308.79,
            '600': 1344.9,
            '1200': 1205.2,
            '3000': 1021.86,
        },
    },
];
